<button class="ap-link show-more px-1" (click)="showModal()">
  {{ 'taxResult.more' | translate }}
</button>
<ap-modal
  #modal
  [appModalId]="modalTitle()"
  class="border border-2 rounded me-2 mt-2"
  [title]="modalTitle()"
  [style]="'width: 50%'">
  <div class="modal-height font-family-georgia">
    @if (isHtmlContent()) {
      <div
        gstarInternalLinks
        [innerHTML]="modalContent() | blankLinks | safe: 'html'"></div>
    } @else {
      <p class="p-3 text-muted pe-none m-0 content white-space-pre">
        {{ modalContent() }}
      </p>
    }
  </div>
</ap-modal>
